angular.module('gym.calendar').factory('DefaultCalendarLocationService', ["$rootScope", "CwStorage", function($rootScope, CwStorage) {
  return {
    get: function(gym, locations) {
      var id, selectedLocation;
      id = parseInt(CwStorage.getItem('selectedLocation'), 10) || gym.attributes.gym_config.default_calendar_location_id;
      selectedLocation = _.find(locations.plain(), function(location) {
        return location.id === id;
      });
      if (id && !selectedLocation) {
        return locations[0];
      } else {
        return selectedLocation;
      }
    }
  };
}]);
